{
  "id": "campaign-010",
  "name": "Dewy Square",
  "seed": "campaign:10",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "HHHH......",
    "HHHH......",
    "____......",
    "...,......",
    "..,,,....#",
    "...,......",
    "......#...",
    ".B......B.",
    ",,,.......",
    ".,........",
    ".........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 6
    },
    {
      "kind": "repair",
      "x": 7,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 10,
  "biome": "backyard",
  "par": {
    "reel": 4194,
    "push": 3157,
    "selfPropelled": 2910,
    "tractor": 2685,
    "zeroTurn": 2000,
    "fairway": 1114
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 17,
      "zeroTurn": 0,
      "fairway": 11
    }
  }
}
